export const es = {
  dashboard: {
    sales: 'Ventas',
    sales_amount: 'Ventas',
    fees: 'Comisiones',
    metas: 'Metas',
    time_to_close: 'Tiempo promedio de cierre',
    days: 'días',
    budget_sales: 'Metas/Ventas',
    DASHBOARD: 'Dashboard',
    ADMIN_DASHBOARD: 'Dashboard Administrativo',
    leads_count: 'Leads',
    projects_count: 'Proyectos',
    lots_count: 'Lotes',
    projection_amount: 'Proyección de Venta',
    line_chart_title: 'Comparación Año Anterior vs Actual',
    select_y_value: 'Seleccionar valor Y',
    bar_chart_title: 'Status de Leads',
    social_networks_table: 'Redes Sociales',
    social_network: 'Red Social',
    pie_chart_title: 'Leads Orgánicos vs Campañas',
    leads_summary: 'Resumen de Leads',
    organic: 'Orgánicos',
    campaigns: 'Campañas',
    total: 'Total',
  },
  login: {
    TITLE: '¡Bienvenido!',
    SUBTITLE: 'Por favor introduce tus credenciales',
    EMAIL: { TEXT: 'Correo', PLACEHOLDER: 'Correo electrónico' },
    PASSWORD: { TEXT: 'Contraseña', PLACEHOLDER: '**********' },
    RECOVER: { TEXT: 'Olvide mi contraseña' },
  },
  'password-recovery': {
    TITLE: 'Recuperar contraseña',
    SUCCESS: {
      SUMMARY: 'Correo enviado',
      DETAIL: 'Revisa tu correo y sigue las instrucciones',
    },
  },
  roles: {
    ADMIN: 'Administrador',
    WAREHOUSEMAN: 'Almacenista',
    COOWNER: 'Copropietario',
    ADVISOR: 'Asesor Interno',
    'EXTERNAL ADVISOR': 'Asesor Externo',
    'MKT COORDINATOR': 'Coordinador MKT',
    'MKT ASSISTANT': 'Asistente MKT',
    'COM COORDINATOR': 'Coordinador COM',
    'COM AUXILIAR': 'Auxiliar COM',
  },
  strings: {
    LOGOUT_SUCCESS: 'Cerraste sesión con éxito',
    PROFILE: 'Perfil',
    HOME: 'Inicio',
    DASHBOARD: 'Dashboard',
    USERS: 'Usuarios',
    ARTICLES: 'Materiales',
    CATEGORIES: 'Categorias',
    TYPES: 'Tipos',
    METRICS: 'Unidades de medida',
    RM: 'Recepción de mercancia',
    PURCHASE_ORDERS: 'Órdenes de compra',
    INVENTORY: 'Inventario',
    HISTORY: 'Kardex',
    RECEPTION: 'Recepciones',
    SUPPLIERS: 'Proveedores',
    WELCOME_USER: 'Bienvenido {attribute}',
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: '¿Estás seguro de continuar, esta acción no se podrá revertir?',
    },
    ARE_YOU_SURE_REVERSIBLE: {
      TITLE: '{attribute}',
      TEXT: '¿Estás seguro de continuar?',
    },
    ARE_YOU_SURE_APPLIED: {
      TITLE: '{attribute}',
      TEXT: 'Al aplicar esta salida tendrá un costo unitario de {attribute}',
    },
    MODAL: {
      ADD: 'Agregar {attribute}',
      EDIT: 'Editar {attribute}',
      APPLIED: 'Aplicar {attribute}',
      SHOW: 'Ver {attribute}',
      PROFILE: 'Mi perfil',
      NEW: 'Nuevo {attribute}',
    },
    SOMETHING_WENT_WRONG: 'Ups! algo salio mal',
    TEMPLATE_DOWNLOADED_SUCCESSFULLY: 'Plantilla descargada exitosamente',
    CRUD_HELPER: '{attribute} con éxito',
    SUBTITLE_SUMMARY: 'Un resumen de sus {attribute}',
    SEARCH: 'Búsqueda',
    ORDER_BY: 'Ordernar',
    NO_DATA_TO_DISPLAY: 'Sin datos para mostrar',
    LOCATIONS: 'Localidades',
    LOCATION_DESTINATION: 'Localidad destino',
    WAREHOUSE_DESTINATION: 'Almacén destino',
    WAREHOUSE: 'Almacén',
    MOVEMENT_REQUEST: 'Movimientos manuales',
    OUT: 'Salida',
    STOCK: 'Existencia',
    APPROXIMATE: 'Aproximado',
    ADVISORS: 'Asesores',
    CRM: 'CRM',
    CXP: 'CXP',
    CXC: 'CXC',
    MANAGEMENT_OF: 'Gestion de {attribute}',
    NEW: 'Nuevo {attribute}',
    ADVISOR: 'Asesores',
    CAMPAIGNS: 'Campañas',
    CAMPAIGN: 'Campañas',
    LEADS: 'Leads',
    PROJECTS: 'Proyectos',
    APPOINTMENTS: 'Citas',
    BUSINESS_NAMES: 'Razones sociales',
    PROJECTS_MANAGEMENT: 'Gestión de proyectos',
    CO_OWNERS: 'Copropietarios',
    GENERAL_INFORMATION: 'Informacion General',
    SALES: 'Ventas',
    CUSTOMERS: 'Clientes',
    SOCIAL_NETWORKS: 'Redes Sociales',
    REFERRALS: 'Referencias',
    BROKERAGE: 'Corretaje',
    TRADITIONAL_MEDIA: 'Medios Tradicionales',
    STATUS_LEADS: 'Estatus de leads',
    LEAD_CREATED_AT: 'Fecha de creación de lead',
  },
  filters: {
    TITLE: 'Filtros',
  },
  actions: {
    LOGIN: 'Iniciar Sesión',
    LOGOUT: 'Cerrar sesión',
    CANCEL: 'Cancelar',
    CLOSE: 'Cerrar',
    ADD: 'Agregar {attribute}',
    ACCEPT: 'Aceptar',
    SAVE: 'Guardar',
    EDIT: 'Editar',
    DELETE: 'Eliminar',
    EXPORT: 'Exportar',
    IMPORT: 'Importar',
    CHOOSE: 'Seleccionar',
    ACTIVATE: 'Activar',
    DETAIL: 'Detalle',
    ADDED: 'Guardado',
    UPDATED: 'Actualizado',
    DOWNLOADED: 'Descargado | Descargar',
    DOWNLOAD_TEMPLATE: 'Descargar Plantilla',
    DELETED: 'Eliminado',
    SEE: 'Ver {attribute}',
    NEW: 'Nuevo {attribute} | Nueva {attribute}',
    APPROVED: 'Aprobar',
    PRINT: 'Imprimir',
    ADD_ARTICLE: 'Agregar artículo',
    RECOVER: 'Recuperar',
    APPLIED: 'Aplicar',
    APPLY: 'Aplicar',
    ENTRY: 'Entrada',
    OUT: 'Salida',
    INACTIVE: 'Inactivar',
    CANCELLED: 'Cancelado',
    WINNER: 'Seleccionar ganadora',
    SALE: 'Crear Venta',
    'DERIVING-FROM': 'Crear Venta',
    ACTIVE: 'Activar',
    CONFIRM: 'Confirmar',
    NEXT_STEP: 'Siguiente paso',
    SUBMITTING: 'Subiendo',
    CONFIRMED: 'Confirmar',
    REPLACE: 'Reemplazar',
    SEARCH: 'Buscar',
    ADD_PARTIALITY: 'Agregar Parcialidad',
    MASSIVE_EDIT: 'Edición masiva',
    RESET: 'Restablecer',
    BUDGETS: 'Presupuestos',
    COMISSION: 'Comisión',
    PENDING: 'Pendiente',
  },
  settings: {
    TITLE: 'Configuración',
    THEME: 'Tema',
    THEME_MODE: { LIGHT: 'Claro', DARK: 'Obscuro' },
    LANG: 'Idioma',
  },
  locale: {
    ES: 'Español',
    EN: 'Ingles',
  },
  users: {
    MODEL: 'Usuario | Usuarios',
    PASSWORD: 'Contraseña',
    PASSWORD_CONFIRM: 'Confirmar contraseña',
  },
  history: {
    MODEL: 'Historial | Historial de interacciones',
  },
  advisors: {
    MODEL: 'Asesor | Asesores',
    TYPE: 'Tipo de asesor',
    VIEW_ALL: 'Ver todos los proyectos',
  },
  campaigns: {
    MODEL: 'Campaña | Campañas',
  },
  comments: {
    MODEL: 'Comentario | Comentarios',
    APPOINTMENT: 'Cita',
  },
  leads: {
    MODEL: 'Lead | Leads',
    TITLE: 'Gestión de lead',
    GENERAL_INFORMATION: 'Información General',
    REFERENCE_INFORMATION: 'Información de referencia',
    INTERACTIONS_HISTORY: 'Historial de interacciones',
    PROJECTS_MANAGEMENT: 'Manejo de proyectos',
    PROSPECTS: 'Prospectos',
    LEAD_TRACKING: 'Seguimiento de Lead',
    ASSIGN_ADVISOR: 'Asignar asesor',
  },
  columns: {
    INDICATOR: 'Indicador',
    USER: 'Usuario',
    PRODUCT: 'Producto',
    NAME: 'Nombre',
    PRICE: 'Precio',
    STATUS: 'Estatus',
    CREATED_AT: 'Fecha de creación',
    UPDATED_AT: 'Ultima modificación',
    SUPPLIER: 'Proveedor',
    DATE: 'Fecha',
    INIT_DATE: 'Fecha de colocación',
    ENTRY_DATE: 'Fecha de llegada',
    TOTAL: 'Total',
    TOTAL_LEADS: 'Total de leads',
    CURRENCY: 'Moneda',
    ACTIONS: 'Acciones',
    FOLIO: 'Folio',
    LAST_NAME: 'Apellido',
    EMAIL: 'Correo',
    ROL: 'Rol',
    TITLE: 'Título',
    DESCRIPTION: 'Descripción',
    PART_NUMBER: 'No.Parte',
    CATEGORY: 'Categoria',
    MOVEMENT_TYPE: 'Tipo de movimiento',
    METRIC: 'U.M',
    ID: 'ID',
    ARTICLE_NAME: 'Nombre artículo',
    ARTICLE: 'Artículo',
    QUANTITY: 'Cantidad',
    UNIT_PRICE: 'Precio Unitario',
    TAX: 'Impuesto',
    WAREHOUSE: 'Almacén',
    REASON: 'Motivo',
    PURCHASE_ORDER: 'Orden de compra',
    RM: 'No.RM',
    TYPE_MOVEMENT: 'T.M',
    CERTIFICATE: 'Certificado | Nota de certificado',
    INITIAL_QUANTITY: 'C.I',
    AMOUNT: 'C',
    FINAL_QUANTITY: 'C.F',
    FOLIO_SUPPLIER_INVOICE: 'Folio de factura de proveedor',
    NO: 'No',
    YES: 'Si',
    PEDIMENT: 'Pedimento',
    REMAINING: 'Restante',
    TO_BE_RECEIVED: 'Por recibir',
    RECEIVED: 'Recibido',
    TOTAL_RECEIVED: 'Total Recibido',
    RFC: 'RFC',
    CONDITIONS: 'Condiciones',
    INITIAL_QUANTITY_TEXT: 'Cantidad inicial',
    AMOUNT_TEXT: 'Cantidad',
    FINAL_QUANTITY_TEXT: 'Cantidad final',
    CERTIFICATE_FOLIO: 'Folio de Certificado',
    UNIT_COST: 'Costo Unitario',
    RELOCATION: 'Reubicaión',
    TRANSFERS: 'Traspasos',
    PHONE: 'Telefono',
    MEDIA: 'Medio',
    SOCIAL_NETWORK: 'Red social | Redes Sociales',
    INITIAL_DATE: 'Fecha inicial',
    END_DATE: 'Fecha final',
    COST: 'Costo',
    EXPECTED_LEADS: 'Leads esperados',
    COSTUMER: 'Cliente',
    ADVISOR: 'Asesor',
    FIRST_NAME: 'Nombre(s)',
    INTEREST_PROJECT: 'Proyecto de interes',
    LEAD_VALUE: 'Valor de Lead',
    ORIGIN: 'Origen',
    CAMPAIGN: 'Campaña',
    COMMENT: 'Comentario',
    TITLE_COMMENT: 'Titulo de comentario',
    REVIEW: 'Prospecto',
    FROM: 'Desde',
    PROJECT: 'Proyecto',
    APPOINTMENT_TYPE: 'Tipo de seguimiento',
    SCHEDULE_APOINTMENT: 'Agendar cita',
    BUSINESS_NAME: 'Razón social',
    TAX_NAME: 'Nombre fiscal',
    CO_OWNERSHIP: 'Copropiedad',
    CO_OWNER: 'Copropietario',
    PERCENTAGE: 'Porcentaje',
    CO_OWNERSHIPS: 'Copropiedades',
    LOT_NAME: 'Nombre del lote',
    BLOCK: 'Manzana',
    SURFACE: 'Superficie',
    COMMON_AREA_PERCENTAGE: 'Porcentaje de área común',
    CONSTRUCTION_PERCENTAGE: 'Porcentaje de construcción',
    PROPERTY_VALUE: 'Valor del inmueble',
    IVA: 'IVA',
    LOTS: 'Lotes',
    HOUSING_COMMERCIAL: 'Habitacional',
    LOT: 'Lote',
    SOLD: 'Vendido',
    INITIAL_DOWN_DEPOSIT: 'Apartado Inicial',
    INITIAL_DOWN_DEPOSIT_DATE: 'Fecha E.I',
    MONTHLY_DEPOSIT: 'Enganche Parcial | Enganches Parciales',
    MONTHLY_DEPOSIT_DATE: 'Fecha E.P',
    TOTAL_DEPOSIT: 'Total Enganches',
    LAST_DEPOSIT: 'Ultimo Enganche',
    PARTIAL_PAYMENT: 'Abono Parcial | Abonos Parciales',
    PARTIAL_PAYMENT_DATE: 'Fecha de parcialidad',
    PARTIAL_PAYMENT_AMOUNT: 'Monto de parcialidad',
    ANNUAL_PAYMENTS: 'Abonos anuales',
    INTEREST_RATE: 'Interés',
    DEADLINE: 'Plazo',
    SALE_DATE: 'Fecha de Venta',
    LOT_STATUS: 'Status Lote',
    QUOTE_STATUS: 'Status Cotización',
    WINNER: 'Ganadora',
    LOT_SOLD: 'Lote Vendido',
    SALE_AMOUNT: 'Monto',
    CUSTOMERS_NAMES: 'Nombres de clientes',
    PATERNAL_LAST_NAME: 'Apellido paterno',
    MATERNAL_LAST_NAME: 'Apellido materno',
    COOWNER_PERCENTAGE: '% de copropiedad',
    PERSON_TYPE: 'Tipo de persona',
    PHYSICAL_PERSON: 'Persona física',
    MORAL_PERSON: 'Persona moral',
    DOCUMENTS: 'Documentos',
    PROPERTY: 'Propiedad',
    TYPE: 'Tipo',
    PROPERTIES: 'Propiedades',
    SALE_DATA: 'Datos de venta',
    BACKGROUNDS: 'Antecedentes',
    ORGANIC: 'Orgánico',
    BUDGET: 'Presupuesto',
    CAMPAIGN_LINK: 'Link de campaña',
    REFERRAL: 'Referencia',
    LEAD: 'Lead',
    BUSINESS_NAME_WITHOUT_REGIME: 'Razón social sin regimen',
    PAYMENT_METHOD: 'Método de pago',
    PAYMENT_FORM: 'Forma de pago',
    CFDI: 'CFDI',
    CLASSIFICATION: 'Clasificación',
    FISCAL_REGIME: 'Régimen fiscal',
    MAIN_CURRENCY: 'Moneda principal',
    INVOICE_EMAIL: 'Correo para facturas',
    PAYMENT_SUPPLEMENTS_EMAIL: 'Correo para complementos de pago',
    TAX_ADDRESS: 'Dirección fiscal',
    STREET: 'Calle',
    INTERNAL_NUMBER: 'Número interior',
    EXTERNAL_NUMBER: 'Número exterior',
    NEIGHBORHOOD: 'Colonia',
    POSTAL_CODE: 'Código postal',
    COUNTRY: 'País',
    STATE: 'Estado',
    LOCALITY: 'Localidad',
    MUNICIPALITY: 'Municipio',
    REFERENCE: 'Referencia',
    BILLING_DATA: 'Datos de facturación',
    LOST_REASON: 'Motivo de perdido',
    CONSTRUCTION_SURFACE: 'Superficie de construcción',
    SALE: 'Venta',
    RENT: 'Renta',
    BROKERAGE: 'Corretaje',
    QUANTITY_LOTS: 'Cantidad de lotes',
    SECURITY_REQUIREMENTS: 'Requerimientos de seguridad',
    RESIDENTIAL_MAINTENANCE_FEE: 'Cuota de mantenimiento habitacional',
    COMMERCIAL_MAINTENANCE_FEE: 'Cuota de mantenimiento comercial',
    LATITUDE: 'Latitud',
    LONGITUDE: 'Longitud',
    CITY: 'Ciudad',
    NUMBER: 'Número',
    AMOUNTS: 'Monto',
    UNITS: 'Unidades',
    COMMISSION: 'Comisión',
    CAMPAING_TYPE: 'Tipo de campaña',
    TRADITIONAL_MEDIA: 'Medio tradicional',
  },
  status: {
    ACTIVED: 'Activo',
    DELETED: 'Eliminado',
    INACTIVED: 'Inactivo',
    REQUESTED: 'En proceso',
    PENDING: 'Pendiente',
    APPLIED: 'Aplicado',
    DONE: 'Completado',
    DRAFTED: 'Borrador',
    CANCELLED: 'Cancelado',
    IN_PROCESS: 'Proceso',
    RECEIVED: 'Recibida',
    APPROVED: 'Aprobado',
    INACTIVE: 'Inactivo',
    FALSE_CONTACT: 'Falso contacto',
    LOCKED: 'Blqueado',
    IN_CONTACT: 'En contacto',
    QUOTED: 'Cotizado',
    POSSIBLE_CLOSURE: 'Posible cierre',
    SALE_FINALIZED: 'Venta finalizada',
    LOST: 'Perdido',
    SENT: 'Enviado',
    TRUE: 'Si',
    FALSE: 'No',
    SOLD: 'Vendido',
    WINNER: 'Ganadora',
    DERIVING_FROM: 'Vendido',
    CONFIRMED: 'Confirmada',
    IN_REVIEW: 'Revisión',
    FIRST_CONTACT: 'Primer contacto',
    SALE_CLOSED: 'Venta cerrada',
    SECOND_CONTACT: 'Segundo contacto',
    NO_ANSWER: 'Sin respuesta',
    BROKER: 'Broker',
    UNWARRANTED: 'Sin justificación',
    NO_BUDGET: 'Sin presupuesto',
    ANOTHER_PRODUCT: 'Busca otro producto',
    TIME: 'Tiempo',
    LOCATION: 'Ubicación',
    ALREDY_BUY: 'Ya compró',
    EMPTY: 'Vacíos',
    REJECTED_BY_COMPANY: 'Rechazado por la empresa',
    NO_INTEREST: 'No le interesa',
    AVAILABLE: 'Disponible',
    RESERVED: 'Apartado',
    NEW: 'Nuevo',
  },
  validation: {
    ACCEPTED: 'El campo {attribute} debe ser aceptado.',
    ACTIVE_URL: 'El campo {attribute} no es una URL válida.',
    AFTER: 'El campo {attribute} debe ser una fecha después a {date}.',
    AFTER_OR_EQUAL:
      'El campo {attribute} debe ser una fecha posterior o igual a {date}.',
    ALPHA: 'El campo {attribute} solo puede contener letras.',
    ALPHA_DASH:
      'El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.',
    ALPHA_NUM: 'El campo {attribute} solo puede contener letras y números.',
    ARRAY: 'El campo {attribute} debe ser una matriz.',
    BEFORE: 'El campo {attribute} debe ser una fecha antes de {date}.',
    BEFORE_OR_EQUAL:
      'El campo {attribute} debe ser una fecha antes o igual a {date}.',
    BETWEEN: {
      NUMERIC: 'El {attribute} debe estar entre {min} y {max}.',
      FILE: 'El {attribute} debe estar entre {min} y {max} kilobytes.',
      STRING: 'El {attribute} debe estar entre {min} y {max} caracteres.',
      ARRAY: 'El {attribute} debe estar entre {min} y {max} artículos.',
    },
    BOOLEAN: 'El campo {attribute} debe ser verdadero o falso.',
    CONFIRMED: 'El {attribute} la confirmación no coincide.',
    DATE: 'La {attribute} no es una fecha valida.',
    DATE_FORMAT: 'La {attribute} no coincide con el formato {format}.',
    DIFFERENT: 'El {attribute} y {other} deben ser diferentes.',
    DIGITS: 'El {attribute} deben ser {digits} dígitos.',
    DIGITS_BETWEEN: 'El {attribute} debe estar entre {min} y {max} dígitos.',
    DIMENSIONS: 'El {attribute} tiene dimensiones de imagen inválidas.',
    DISTINCT: 'El {attribute} campo tiene un valor duplicado.',
    EMAIL:
      'El campo {attribute} debe ser una dirección de correo electrónico válida.',
    EXISTS: 'El seleccionado {attribute} no es válido.',
    FILE: 'El {attribute} debe ser un archivo.',
    FILLED: 'El {attribute} campo debe tener un valor.',
    GT: {
      NUMERIC: 'El {attribute} debe ser mayor que {value}.',
      FILE: 'El {attribute} debe ser mayor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener más que {value} artículos.',
    },
    GTE: {
      NUMERIC: 'El {attribute} debe ser mayor o igual que {value}.',
      FILE: 'El {attribute} debe ser mayor o igual que {value} kilobytes.',
      STRING: 'El {attribute} debe ser mayor o igual que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener {value} artículos o más.',
    },
    IMAGE: 'La {attribute} debe ser una imagen.',
    IN: 'El seleccionado {attribute} no es válido.',
    IN_ARRAY: 'El {attribute} campo no existe en {other}.',
    INTEGER: 'El {attribute} debe ser un entero.',
    IP: 'La {attribute} debe ser una dirección IP válida.',
    IPV4: 'La {attribute} debe ser una dirección IPv4 válida.',
    IPV6: 'La {attribute} debe ser una dirección IPv6 válida.',
    JSON: 'La {attribute} debe ser una cadena JSON válida.',
    LT: {
      NUMERIC: 'El {attribute} debe ser menor que {value}.',
      FILE: 'El {attribute} debe ser menor que {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor que {value} caracteres.',
      ARRAY: 'El {attribute} debe tener menos que {value} artículos.',
    },
    LTE: {
      NUMERIC: 'El {attribute} debe ser menor o igual {value}.',
      FILE: 'El {attribute} debe ser menor o igual {value} kilobytes.',
      STRING: 'El {attribute} debe ser menor o igual {value} caracteres.',
      ARRAY: 'El {attribute} no debe tener más de {value} artículos.',
    },
    MAX: {
      NUMERIC: 'El {attribute} no puede ser mayor que {max}.',
      FILE: 'El {attribute} no puede ser mayor que {max} kilobytes.',
      STRING: 'El {attribute} no puede ser mayor que {max} caracteres.',
      ARRAY: 'El {attribute} no puede tener más de {max} artículos.',
    },
    MIMES: 'El {attribute} must be a file of type: {values}.',
    MIMETYPES: 'Los {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'El campo {attribute} debe ser al menos de {min}.',
      FILE: 'El campo {attribute} debe ser al menos de {min} kilobytes.',
      STRING: 'El campo {attribute} debe ser al menos de {min} caracteres.',
      ARRAY: 'El campo {attribute} debe tener al menos {min} artículos.',
    },
    NOT_IN: 'El seleccionado {attribute} no es válido.',
    NOT_REGEX: 'El {attribute} formato no es válido.',
    NUMERIC: 'El campo {attribute} tiene que ser un número.',
    PRESENT: 'El campo {attribute} debe estar presente.',
    REGEX: 'El campo {attribute} formato no es válido.',
    REQUIRED: 'El campo {attribute} es requerido.',
    REQUIRED_IF: 'El campo {attribute} es requerido cuando {other} es {value}.',
    REQUIRED_UNLESS:
      'El campo {attribute} es requerido a menos que {other} es en {values}.',
    REQUIRED_WITH:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITH_ALL:
      'El campo {attribute} es requerido cuando {values} esta presente.',
    REQUIRED_WITHOUT:
      'El campo {attribute} es requerido cuando {values} no esta presente.',
    REQUIRED_WITHOUT_ALL:
      'El campo {attribute} es requerido cuando ninguno de {values} estan presentes.',
    SAME: 'El campo {attribute} debe coincidir con {other}.',
    SIZE: {
      NUMERIC: 'El {attribute} debe ser {size}.',
      FILE: 'El {attribute} debe ser {size} kilobytes.',
      STRING: 'El {attribute} debe ser {size} caracteres.',
      ARRAY: 'El {attribute} debe contener {size} artículos.',
    },
    STRING: 'El {attribute} debe ser un texto.',
    TIMEZONE: 'El {attribute} debe ser una zona válida.',
    UNIQUE: 'El {attribute} ya se ha tomado.',
    UPLOADED: 'El {attribute} no se pudo cargar.',
    URL: 'El {attribute} formato no válido.',
    PASSWORD_EQUALS: 'Las contraseñas no coinciden.',
    ATTRIBUTES: {},
  },
  date: {
    OF: ' de ',
    OF_THE: ' del ',
  },
  projects: {
    MODEL: 'Proyecto | Proyectos',
  },
  appointments: {
    MODEL: 'Cita | Citas',
    CALENDAR: 'Calendario',
  },
  'business-names': {
    MODEL: 'Razon Social | Razones Sociales',
  },
  'co-owners': {
    MODEL: 'Copropietario | Copropietarios',
  },
  'co-ownerships': {
    MODEL: 'Copropiedad | Copropiedades',
  },
  lots: {
    MODEL: 'Lote | Lotes',
  },
  quotations: {
    MODEL: 'Cotizacion | Cotizaciones',
    AMORTIZATION: 'Tabla de amortización',
    VALIDATIONS: {
      MONTHLY_DEPOSIT: 'El enganche parcial debe ser minimo 0',
      MONTHLY_DEPOSIT_DATE: 'La fecha del enganche parcial es requerida',
      INTEREST_RATE: 'La tasa de interés debe ser minimo de 0',
    },
  },
  sales: {
    MODEL: 'Venta | Ventas',
    CONFIRMED: 'Ventas confirmadas',
    IN_REVIEW: 'Ventas en revisión',
    DRAFTED: 'Ventas en borrador',
    PROJECT_LOT: 'Proyecto y lote',
    CREATE_CUSTOMER: 'Crear cliente y copropiedad',
    DOCUMENTATION: 'Documentación',
    SELECT_PROJECT: 'Selecciona el proyecto y el lote',
    CREATE_A_CUSTOMER: 'Crea un cliente',
    CUSTOMERS: 'Clientes',
    COOWNER_PERCENTAGE_VALIDATION:
      'Las copropiedades deben de dar 100% en total',
    FILES_VALIDATION: 'Todos los documentos deben ser subidos para guardar',
    CUSTOMER_DETAIL: 'Detalles por cliente',
    TITLE: 'Gestión de ventas',
    UPDATED_AT: 'Fecha de actualización',
    DOCUMENT: 'Documento',
  },
  customers: {
    MODEL: 'Cliente | Clientes',
  },
  referrals: {
    MODEL: 'Referencia | Referencias',
  },
  'social-networks': {
    MODEL: 'Red Social | Redes sociales',
  },
  brokerage: {
    MODEL: 'Corretaje | Corretajes',
  },
  budgets: {
    MODEL: 'Prespuesto | Presupuestos',
  },
  commission: {
    MODEL: 'Comisión | Comisiones',
  },
  traditional_media: {
    MODEL: 'Medio tradicional | Medios tradicionales',
  },
}
